export const provinceMaps = [
  {
    key: 'bohol-province',
    title: 'Bohol Province Overview',
    description: 'Province-wide cacao land suitability summary for Bohol.',
    assetPath: '/map/LandSuitability(Bohol)/Landsuit Bohol.jpg',
    category: 'province',
    labels: ['Province Overview'],
  },
];

export const factorMaps = [
  {
    key: 'drainage',
    title: 'Drainage Map',
    description: 'Cacao requirement map for drainage conditions.',
    assetPath: '/map/LandSuitability(CacaoRequirements)/Suitability Map for Drainage.jpg',
    category: 'factor',
    labels: ['Drainage', 'Requirement'],
  },
  {
    key: 'nitrogen',
    title: 'Nitrogen Map',
    description: 'Cacao requirement map for nitrogen availability.',
    assetPath: '/map/LandSuitability(CacaoRequirements)/Suitability Map for Nitrogen.jpg',
    category: 'factor',
    labels: ['Nitrogen', 'Requirement'],
  },
  {
    key: 'organic-matter',
    title: 'Organic Matter Map',
    description: 'Cacao requirement map for organic matter distribution.',
    assetPath: '/map/LandSuitability(CacaoRequirements)/Suitability Map for Organic Matter.jpg',
    category: 'factor',
    labels: ['Organic Matter', 'Requirement'],
  },
  {
    key: 'ph',
    title: 'Soil pH Map',
    description: 'Cacao requirement map for soil pH suitability.',
    assetPath: '/map/LandSuitability(CacaoRequirements)/Suitability Map for pH.jpg',
    category: 'factor',
    labels: ['pH', 'Requirement'],
  },
  {
    key: 'phosphorus',
    title: 'Phosphorus Map',
    description: 'Cacao requirement map for phosphorus availability.',
    assetPath: '/map/LandSuitability(CacaoRequirements)/Suitability Map for Phosphorus.jpg',
    category: 'factor',
    labels: ['Phosphorus', 'Requirement'],
  },
  {
    key: 'potassium',
    title: 'Potassium Map',
    description: 'Cacao requirement map for potassium availability.',
    assetPath: '/map/LandSuitability(CacaoRequirements)/Suitability Map for Potassium.jpg',
    category: 'factor',
    labels: ['Potassium', 'Requirement'],
  },
  {
    key: 'rainfall',
    title: 'Rainfall Map',
    description: 'Cacao requirement map for rainfall suitability.',
    assetPath: '/map/LandSuitability(CacaoRequirements)/Suitability Map for Rainfall.jpg',
    category: 'factor',
    labels: ['Rainfall', 'Requirement'],
  },
  {
    key: 'slope',
    title: 'Slope Map',
    description: 'Cacao requirement map for slope suitability.',
    assetPath: '/map/LandSuitability(CacaoRequirements)/Suitability Map for Slope.jpg',
    category: 'factor',
    labels: ['Slope', 'Requirement'],
  },
  {
    key: 'temperature',
    title: 'Temperature Map',
    description: 'Cacao requirement map for temperature suitability.',
    assetPath: '/map/LandSuitability(CacaoRequirements)/Suitability Map for Temperature.jpg',
    category: 'factor',
    labels: ['Temperature', 'Requirement'],
  },
  {
    key: 'texture',
    title: 'Texture Map',
    description: 'Cacao requirement map for soil texture suitability.',
    assetPath: '/map/LandSuitability(CacaoRequirements)/Suitability Map for Texture.jpg',
    category: 'factor',
    labels: ['Texture', 'Requirement'],
  },
];

export const samplingMap = {
  key: 'sampling-site',
  title: 'Sampling Site Map',
  description: 'Sampling site distribution used for cacao suitability analysis.',
  assetPath: '/map/SamplingSite/Sampling_Site.jpg',
  category: 'sampling',
  labels: ['Sampling Site'],
};

export const municipalityMaps = [
  {
    key: 'Alburquerque',
    title: 'Cacao Land Suitability Map',
    subtitle: 'Municipality of Alburquerque',
    municipality: 'Alburquerque',
    aliases: ['Albur'],
    description: 'GIS-exported land suitability map for Alburquerque.',
    assetPath: '/map/Land Suitability (Municipality)/Albur/Albur4.jpg',
    category: 'municipality',
  },
  {
    key: 'Alicia',
    title: 'Cacao Land Suitability Map',
    subtitle: 'Municipality of Alicia',
    municipality: 'Alicia',
    aliases: [],
    description: 'GIS-exported land suitability map for Alicia.',
    assetPath: '/map/Land Suitability (Municipality)/Alicia/Alicia_Landsuit.jpg',
    category: 'municipality',
  },
  {
    key: 'Anda',
    title: 'Cacao Land Suitability Map',
    subtitle: 'Municipality of Anda',
    municipality: 'Anda',
    aliases: [],
    description: 'GIS-exported land suitability map for Anda.',
    assetPath: '/map/Land Suitability (Municipality)/Anda/Anda_Landsuit2.jpg',
    category: 'municipality',
  },
  {
    key: 'Antequera',
    title: 'Cacao Land Suitability Map',
    subtitle: 'Municipality of Antequera',
    municipality: 'Antequera',
    aliases: [],
    description: 'GIS-exported land suitability map for Antequera.',
    assetPath: '/map/Land Suitability (Municipality)/Antequera/Antequera_Landsuit.jpg',
    category: 'municipality',
  },
  {
    key: 'Baclayon',
    title: 'Cacao Land Suitability Map',
    subtitle: 'Municipality of Baclayon',
    municipality: 'Baclayon',
    aliases: [],
    description: 'GIS-exported land suitability map for Baclayon.',
    assetPath: '/map/Land Suitability (Municipality)/Baclayon/Baclayon.jpg',
    category: 'municipality',
  },
  {
    key: 'Balilihan',
    title: 'Cacao Land Suitability Map',
    subtitle: 'Municipality of Balilihan',
    municipality: 'Balilihan',
    aliases: [],
    description: 'GIS-exported land suitability map for Balilihan.',
    assetPath: '/map/Land Suitability (Municipality)/Balilihan/Balilihan.jpg',
    category: 'municipality',
  },
  {
    key: 'Batuan',
    title: 'Cacao Land Suitability Map',
    subtitle: 'Municipality of Batuan',
    municipality: 'Batuan',
    aliases: [],
    description: 'GIS-exported land suitability map for Batuan.',
    assetPath: '/map/Land Suitability (Municipality)/Batuan/Batuan.jpg',
    category: 'municipality',
  },
  {
    key: 'Bien Unido',
    title: 'Cacao Land Suitability Map',
    subtitle: 'Municipality of Bien Unido',
    municipality: 'Bien Unido',
    aliases: ['Bien_Unido'],
    description: 'GIS-exported land suitability map for Bien Unido.',
    assetPath: '/map/Land Suitability (Municipality)/Bien Unido/Bien_Unido.jpg',
    category: 'municipality',
  },
  {
    key: 'Bilar',
    title: 'Cacao Land Suitability Map',
    subtitle: 'Municipality of Bilar',
    municipality: 'Bilar',
    aliases: [],
    description: 'GIS-exported land suitability map for Bilar.',
    assetPath: '/map/Land Suitability (Municipality)/Bilar/Bilar.jpg',
    category: 'municipality',
  },
  {
    key: 'Buenavista',
    title: 'Cacao Land Suitability Map',
    subtitle: 'Municipality of Buenavista',
    municipality: 'Buenavista',
    aliases: [],
    description: 'GIS-exported land suitability map for Buenavista.',
    assetPath: '/map/Land Suitability (Municipality)/Buenavista/Buenavista.jpg',
    category: 'municipality',
  },
  {
    key: 'Calape',
    title: 'Cacao Land Suitability Map',
    subtitle: 'Municipality of Calape',
    municipality: 'Calape',
    aliases: [],
    description: 'GIS-exported land suitability map for Calape.',
    assetPath: '/map/Land Suitability (Municipality)/Calape/Calape_Landsuit.jpg',
    category: 'municipality',
  },
  {
    key: 'Candijay',
    title: 'Cacao Land Suitability Map',
    subtitle: 'Municipality of Candijay',
    municipality: 'Candijay',
    aliases: [],
    description: 'GIS-exported land suitability map for Candijay.',
    assetPath: '/map/Land Suitability (Municipality)/Candijay/Candijay_Landsuit2.jpg',
    category: 'municipality',
  },
  {
    key: 'Carmen',
    title: 'Cacao Land Suitability Map',
    subtitle: 'Municipality of Carmen',
    municipality: 'Carmen',
    aliases: [],
    description: 'GIS-exported land suitability map for Carmen.',
    assetPath: '/map/Land Suitability (Municipality)/Carmen/Carmen_Lsuit.jpg',
    category: 'municipality',
  },
  {
    key: 'Catigbian',
    title: 'Cacao Land Suitability Map',
    subtitle: 'Municipality of Catigbian',
    municipality: 'Catigbian',
    aliases: [],
    description: 'GIS-exported land suitability map for Catigbian.',
    assetPath: '/map/Land Suitability (Municipality)/Catigbian/Catigbian_Lsuit.jpg',
    category: 'municipality',
  },
  {
    key: 'Clarin',
    title: 'Cacao Land Suitability Map',
    subtitle: 'Municipality of Clarin',
    municipality: 'Clarin',
    aliases: [],
    description: 'GIS-exported land suitability map for Clarin.',
    assetPath: '/map/Land Suitability (Municipality)/Clarin/Clarin_Lsuit.jpg',
    category: 'municipality',
  },
  {
    key: 'Corella',
    title: 'Cacao Land Suitability Map',
    subtitle: 'Municipality of Corella',
    municipality: 'Corella',
    aliases: [],
    description: 'GIS-exported land suitability map for Corella.',
    assetPath: '/map/Land Suitability (Municipality)/Corella/Corella_Lsuit.jpg',
    category: 'municipality',
  },
  {
    key: 'Cortes',
    title: 'Cacao Land Suitability Map',
    subtitle: 'Municipality of Cortes',
    municipality: 'Cortes',
    aliases: [],
    description: 'GIS-exported land suitability map for Cortes.',
    assetPath: '/map/Land Suitability (Municipality)/Cortes/Cortes_Lsuit.jpg',
    category: 'municipality',
  },
  {
    key: 'Dagohoy',
    title: 'Cacao Land Suitability Map',
    subtitle: 'Municipality of Dagohoy',
    municipality: 'Dagohoy',
    aliases: [],
    description: 'GIS-exported land suitability map for Dagohoy.',
    assetPath: '/map/Land Suitability (Municipality)/Dagohoy/Dagohoy_Lsuit.jpg',
    category: 'municipality',
  },
  {
    key: 'Danao',
    title: 'Cacao Land Suitability Map',
    subtitle: 'Municipality of Danao',
    municipality: 'Danao',
    aliases: [],
    description: 'GIS-exported land suitability map for Danao.',
    assetPath: '/map/Land Suitability (Municipality)/Danao/Danao_Lsuit.jpg',
    category: 'municipality',
  },
  {
    key: 'Dauis',
    title: 'Cacao Land Suitability Map',
    subtitle: 'Municipality of Dauis',
    municipality: 'Dauis',
    aliases: [],
    description: 'GIS-exported land suitability map for Dauis.',
    assetPath: '/map/Land Suitability (Municipality)/Dauis/Dauis_Lsuit.jpg',
    category: 'municipality',
  },
  {
    key: 'Dimiao',
    title: 'Cacao Land Suitability Map',
    subtitle: 'Municipality of Dimiao',
    municipality: 'Dimiao',
    aliases: [],
    description: 'GIS-exported land suitability map for Dimiao.',
    assetPath: '/map/Land Suitability (Municipality)/Dimiao/Dimiao_Lsuit.jpg',
    category: 'municipality',
  },
  {
    key: 'Duero',
    title: 'Cacao Land Suitability Map',
    subtitle: 'Municipality of Duero',
    municipality: 'Duero',
    aliases: [],
    description: 'GIS-exported land suitability map for Duero.',
    assetPath: '/map/Land Suitability (Municipality)/Duero/Duero_Lsuit.jpg',
    category: 'municipality',
  },
  {
    key: 'Garcia Hernandez',
    title: 'Cacao Land Suitability Map',
    subtitle: 'Municipality of Garcia Hernandez',
    municipality: 'Garcia Hernandez',
    aliases: ['Garcia_Hernandez'],
    description: 'GIS-exported land suitability map for Garcia Hernandez.',
    assetPath: '/map/Land Suitability (Municipality)/Garcia Hernandez/Garcia_Lsuit.jpg',
    category: 'municipality',
  },
  {
    key: 'Getafe',
    title: 'Cacao Land Suitability Map',
    subtitle: 'Municipality of Getafe',
    municipality: 'Getafe',
    aliases: [],
    description: 'GIS-exported land suitability map for Getafe.',
    assetPath: '/map/Land Suitability (Municipality)/Getafe/Getafe.jpg',
    category: 'municipality',
  },
  {
    key: 'Guindulman',
    title: 'Cacao Land Suitability Map',
    subtitle: 'Municipality of Guindulman',
    municipality: 'Guindulman',
    aliases: ['Guindulman-lsuit'],
    description: 'GIS-exported land suitability map for Guindulman.',
    assetPath: '/map/Land Suitability (Municipality)/Guindulman/Guindulman-lsuit.jpg',
    category: 'municipality',
  },
  {
    key: 'Inabanga',
    title: 'Cacao Land Suitability Map',
    subtitle: 'Municipality of Inabanga',
    municipality: 'Inabanga',
    aliases: [],
    description: 'GIS-exported land suitability map for Inabanga.',
    assetPath: '/map/Land Suitability (Municipality)/Inabanga/Inabanga_Lsuit.jpg',
    category: 'municipality',
  },
  {
    key: 'Jagna',
    title: 'Cacao Land Suitability Map',
    subtitle: 'Municipality of Jagna',
    municipality: 'Jagna',
    aliases: [],
    description: 'GIS-exported land suitability map for Jagna.',
    assetPath: '/map/Land Suitability (Municipality)/Jagna/Jagna_Lsuit.jpg',
    category: 'municipality',
  },
  {
    key: 'Lila',
    title: 'Cacao Land Suitability Map',
    subtitle: 'Municipality of Lila',
    municipality: 'Lila',
    aliases: [],
    description: 'GIS-exported land suitability map for Lila.',
    assetPath: '/map/Land Suitability (Municipality)/Lila/Lila_Lsuit.jpg',
    category: 'municipality',
  },
  {
    key: 'Loay',
    title: 'Cacao Land Suitability Map',
    subtitle: 'Municipality of Loay',
    municipality: 'Loay',
    aliases: [],
    description: 'GIS-exported land suitability map for Loay.',
    assetPath: '/map/Land Suitability (Municipality)/Loay/Loay_Lsuit.jpg',
    category: 'municipality',
  },
  {
    key: 'Loboc',
    title: 'Cacao Land Suitability Map',
    subtitle: 'Municipality of Loboc',
    municipality: 'Loboc',
    aliases: [],
    description: 'GIS-exported land suitability map for Loboc.',
    assetPath: '/map/Land Suitability (Municipality)/Loboc/Loboc_Lsuit.jpg',
    category: 'municipality',
  },
  {
    key: 'Loon',
    title: 'Cacao Land Suitability Map',
    subtitle: 'Municipality of Loon',
    municipality: 'Loon',
    aliases: [],
    description: 'GIS-exported land suitability map for Loon.',
    assetPath: '/map/Land Suitability (Municipality)/Loon/Loon_Lsuit.jpg',
    category: 'municipality',
  },
  {
    key: 'Mabini',
    title: 'Cacao Land Suitability Map',
    subtitle: 'Municipality of Mabini',
    municipality: 'Mabini',
    aliases: [],
    description: 'GIS-exported land suitability map for Mabini.',
    assetPath: '/map/Land Suitability (Municipality)/Mabini/Mabini_Lsuit.jpg',
    category: 'municipality',
  },
  {
    key: 'Maribojoc',
    title: 'Cacao Land Suitability Map',
    subtitle: 'Municipality of Maribojoc',
    municipality: 'Maribojoc',
    aliases: [],
    description: 'GIS-exported land suitability map for Maribojoc.',
    assetPath: '/map/Land Suitability (Municipality)/Maribojoc/Maribojoc_Lsuit.jpg',
    category: 'municipality',
  },
  {
    key: 'Panglao',
    title: 'Cacao Land Suitability Map',
    subtitle: 'Municipality of Panglao',
    municipality: 'Panglao',
    aliases: [],
    description: 'GIS-exported land suitability map for Panglao.',
    assetPath: '/map/Land Suitability (Municipality)/Panglao/Panglao_Lsuit.jpg',
    category: 'municipality',
  },
  {
    key: 'Pilar',
    title: 'Cacao Land Suitability Map',
    subtitle: 'Municipality of Pilar',
    municipality: 'Pilar',
    aliases: [],
    description: 'GIS-exported land suitability map for Pilar.',
    assetPath: '/map/Land Suitability (Municipality)/Pilar/Pilar_Lsuit.jpg',
    category: 'municipality',
  },
  {
    key: 'Pres. Carlos P. Garcia',
    title: 'Cacao Land Suitability Map',
    subtitle: 'Municipality of Pres. Carlos P. Garcia',
    municipality: 'Pres. Carlos P. Garcia',
    aliases: ['Pres CPG', 'Pres. CPG', 'Pres. Carlos P. Garcia (Pitogo)'],
    description: 'GIS-exported land suitability map for Pres. Carlos P. Garcia.',
    assetPath: '/map/Land Suitability (Municipality)/Pres CPG/CPG_Lsuit.jpg',
    category: 'municipality',
  },
  {
    key: 'Sagbayan',
    title: 'Cacao Land Suitability Map',
    subtitle: 'Municipality of Sagbayan',
    municipality: 'Sagbayan',
    aliases: [],
    description: 'GIS-exported land suitability map for Sagbayan.',
    assetPath: '/map/Land Suitability (Municipality)/Sagbayan/Sagbayan_Lsuit.jpg',
    category: 'municipality',
  },
  {
    key: 'San Isidro',
    title: 'Cacao Land Suitability Map',
    subtitle: 'Municipality of San Isidro',
    municipality: 'San Isidro',
    aliases: [],
    description: 'GIS-exported land suitability map for San Isidro.',
    assetPath: '/map/Land Suitability (Municipality)/San Isidro/SanIsid_Lsuit.jpg',
    category: 'municipality',
  },
  {
    key: 'San Miguel',
    title: 'Cacao Land Suitability Map',
    subtitle: 'Municipality of San Miguel',
    municipality: 'San Miguel',
    aliases: ['SanMig'],
    description: 'GIS-exported land suitability map for San Miguel.',
    assetPath: '/map/Land Suitability (Municipality)/San Miguel/SanMig_Lsuit.jpg',
    category: 'municipality',
  },
  {
    key: 'Sevilla',
    title: 'Cacao Land Suitability Map',
    subtitle: 'Municipality of Sevilla',
    municipality: 'Sevilla',
    aliases: [],
    description: 'GIS-exported land suitability map for Sevilla.',
    assetPath: '/map/Land Suitability (Municipality)/Sevilla/Sevilla_Lsuit.jpg',
    category: 'municipality',
  },
  {
    key: 'Sierra Bullones',
    title: 'Cacao Land Suitability Map',
    subtitle: 'Municipality of Sierra Bullones',
    municipality: 'Sierra Bullones',
    aliases: ['Sierra'],
    description: 'GIS-exported land suitability map for Sierra Bullones.',
    assetPath: '/map/Land Suitability (Municipality)/Sierra Bullones/Sierra_Lsuit.jpg',
    category: 'municipality',
  },
  {
    key: 'Sikatuna',
    title: 'Cacao Land Suitability Map',
    subtitle: 'Municipality of Sikatuna',
    municipality: 'Sikatuna',
    aliases: [],
    description: 'GIS-exported land suitability map for Sikatuna.',
    assetPath: '/map/Land Suitability (Municipality)/Sikatuna/Sikatuna_Lsuit.jpg',
    category: 'municipality',
  },
  {
    key: 'Tagbilaran City',
    title: 'Cacao Land Suitability Map',
    subtitle: 'Municipality of Tagbilaran City',
    municipality: 'Tagbilaran City',
    aliases: ['Tagbilaran'],
    description: 'GIS-exported land suitability map for Tagbilaran City.',
    assetPath: '/map/Land Suitability (Municipality)/Tagbilaran/Tagbilaran_Lsuit.jpg',
    category: 'municipality',
  },
  {
    key: 'Talibon',
    title: 'Cacao Land Suitability Map',
    subtitle: 'Municipality of Talibon',
    municipality: 'Talibon',
    aliases: [],
    description: 'GIS-exported land suitability map for Talibon.',
    assetPath: '/map/Land Suitability (Municipality)/Talibon/Talibon_Lsuit.jpg',
    category: 'municipality',
  },
  {
    key: 'Trinidad',
    title: 'Cacao Land Suitability Map',
    subtitle: 'Municipality of Trinidad',
    municipality: 'Trinidad',
    aliases: [],
    description: 'GIS-exported land suitability map for Trinidad.',
    assetPath: '/map/Land Suitability (Municipality)/Trinidad/Trinidad_Lsuit.jpg',
    category: 'municipality',
  },
  {
    key: 'Tubigon',
    title: 'Cacao Land Suitability Map',
    subtitle: 'Municipality of Tubigon',
    municipality: 'Tubigon',
    aliases: [],
    description: 'GIS-exported land suitability map for Tubigon.',
    assetPath: '/map/Land Suitability (Municipality)/Tubigon/Tubigon_Lsuit.jpg',
    category: 'municipality',
  },
  {
    key: 'Ubay',
    title: 'Cacao Land Suitability Map',
    subtitle: 'Municipality of Ubay',
    municipality: 'Ubay',
    aliases: [],
    description: 'GIS-exported land suitability map for Ubay.',
    assetPath: '/map/Land Suitability (Municipality)/Ubay/Ubay_Lsuit.jpg',
    category: 'municipality',
  },
  {
    key: 'Valencia',
    title: 'Cacao Land Suitability Map',
    subtitle: 'Municipality of Valencia',
    municipality: 'Valencia',
    aliases: [],
    description: 'GIS-exported land suitability map for Valencia.',
    assetPath: '/map/Land Suitability (Municipality)/Valencia/valencia_lsuit.jpg',
    category: 'municipality',
  },
];

export const municipalityLookup = municipalityMaps.reduce((lookup, map) => {
  lookup[map.municipality] = map;
  lookup[map.key] = map;
  (map.aliases || []).forEach((alias) => {
    lookup[alias] = map;
  });
  return lookup;
}, {});

export const suitabilityCollections = {
  province: provinceMaps,
  factor: factorMaps,
  sampling: [samplingMap],
  municipality: municipalityMaps,
};
